import axios from "axios";

import { sortArrByName } from "../helpers/arrayHandlers";

export const getDeviceModelsAPI = async () => {
  let response = await axios({
    url: `/api/v2/admin-utility/device-models`,
    method: "GET"
  });
  const allModelNames = response.data.device_models;
  const sortedModelNameArr = sortArrByName(allModelNames);
  return sortedModelNameArr;
};
